var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navigation'),_c('Header'),_c('firstSection'),_c('Features'),_c('sectionTours'),_c('Pop_up'),_c('Testimonios'),_c('Booking'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }